import { isExcludedFromSrpPatch } from '@/utils/a6LifecycleFields'

export function buildCustomFeedUpdateFields(params: {
  rawVehicle: Record<string, unknown>
  validFieldKeys: string[]
}): Record<string, unknown> {
  const { rawVehicle, validFieldKeys } = params
  const validSet = new Set(validFieldKeys)
  const useAllowlist = validSet.size > 0

  const out: Record<string, unknown> = {}

  for (const [key, value] of Object.entries(rawVehicle)) {
    // Never send identifiers / non-field keys as "fields"
    if (key === 'vin' || key === 'jazelId' || key === 'juid') continue

    // Legacy passive tolerance: older records may still carry a custom-feed `lock` field. It is no
    // longer a vehicle field, is never authored, and must never be sent back through the payload.
    if (key === 'lock') continue

    // A6: operational inventory attributes (inventoryState/inventoryUsageType/website visibility)
    // and system/workflow fields must never be sent through the SRP custom-feed payload or the
    // VehicleDraft field patch. Operational attributes are dealer-authored but travel through the
    // operationalPatch path instead (see saveVehicle); system/workflow fields are never authored.
    if (isExcludedFromSrpPatch(key)) continue

    // Never send UI-only / derived keys (even if allowlist is empty)
    if (
      key === 'segments_sidebar' ||
      key === 'segments' ||
      key === 'feedType' ||
      key === 'feedSources' ||
      key === 'status' ||
      key === 'visibility' ||
      key === 'visibilityReason'
    ) {
      continue
    }

    // If we have a mapping-derived allowlist, only send those keys.
    if (useAllowlist && !validSet.has(key) && key !== 'conditions') continue

    if (value === undefined) continue

    out[key] = value
  }

  return out
}
